import { Slot } from '@radix-ui/react-slot'
import type { VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

import { buttonVariants } from './button-variants'

interface ButtonProps extends ComponentProps<'button'>, VariantProps<typeof buttonVariants> {
  /** `true` ise stiller tek çocuğa uygulanır (ör. router `<Link>`). */
  readonly asChild?: boolean
}

export function Button({ className, variant, size, asChild = false, ...props }: ButtonProps) {
  const Component = asChild ? Slot : 'button'

  return <Component className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
